import React from 'react';
import completeIcon from '../../assets/complete.png';
import { message, Modal, Tooltip } from 'antd';
import { CheckCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import './completeDoc.css';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { workwiseServices } from '../../Workw-Api/api';
import { loadSpreadsheetData } from '../../utils/api';
import { useParams } from "react-router-dom";
import { useSpreadSheet } from '../../context/spreadsheet-context';

const { confirm } = Modal;

const CompleteDocument = () => {

    const { id } = useParams();
    const { documentInfo, isReadOnly, setIsReadOnly, } = useDocument();
    const { spreadsheetInstanceRef } = useSpreadSheet();

    const handleClick = async () => {
        try {
            await workwiseServices.completeDocument(documentInfo.referenceId);
            const sheetData = await loadSpreadsheetData(id);
            spreadsheetInstanceRef.current.loadData(
                sheetData,
                isReadOnly
            );
            message.success('Document completed successfully.');
            setIsReadOnly(true);
        } catch (error) {
            message.error('Failed to complete the document. Please try again.');
        }
    };

    const showConfirmationModal = (e) => {
        e.preventDefault();
        confirm({
            className: 'complete-doc-confirm',
            icon: null,
            title: (
                <>
                    <span className="complete-doc-confirm__badge">
                        <ExclamationCircleOutlined />
                    </span>
                    <span className="complete-doc-confirm__title">Complete this document?</span>
                </>
            ),
            content: (
                <>
                    <p className="complete-doc-confirm__text">
                        Once completed, this document is locked. You won't be able to edit or reopen it.
                    </p>
                </>
            ),
            okText: (
                <>
                    <CheckCircleFilled />
                    Complete document
                </>
            ),
            okButtonProps: { type: 'primary' },
            closable: true,
            cancelText: 'Cancel',
            onOk() {
                handleClick();
            },
            onCancel() {
            },
            zIndex: 9999,
            maskClosable: true,
        });
    };

    return (
        <Tooltip title='Complete document'>
            <div
                style={{
                    marginLeft: "4px",
                    display: "flex",
                    cursor: 'pointer'
                }}
                onClick={(e) => showConfirmationModal(e)}
            >
                <img src={completeIcon} width={16} alt="Complete Document" />
            </div>
        </Tooltip>
    );
};

export default CompleteDocument;